import API from 'app/utils/apiClient';
import { toParams } from 'app/utils/url';

const getRecommendationsV2 = (lastEvaluatedKey) => {
  const params = toParams({ lastEvaluatedKey }, true);
  return API.get(`/v4/recommendation-stories/${params}`);
};

const getRecommendationEpisodeInfo = (storyId) =>
  API.get(`/v2/search/recommendation/stories/${storyId}/episode-info/`);

const searchTags = (q, page = 1, perPage = 20, withProtected = true) => {
  const params = toParams(
    {
      q,
      page,
      perPage,
      withProtected,
    },
    true
  );
  return API.get(`/search/tags/${params}`);
};

// elastic search
const esSearchAll = (q) => {
  const params = toParams({ q }, true);
  return API.get(`/es/all/${params}`);
};

const esSearchStories = (q, lastEvaluatedKey) => {
  const params = toParams({ q, lastEvaluatedKey }, true);
  return API.get(`/es/stories/${params}`);
};

const esSearchUsers = (q, lastEvaluatedKey) => {
  const params = toParams({ q, lastEvaluatedKey }, true);
  return API.get(`/es/users/${params}`);
};

const esSearchTags = (q, lastEvaluatedKey, p = true) => {
  const params = toParams({ q, lastEvaluatedKey, p }, true);
  return API.get(`/es/tags/${params}`);
};

export default {
  getRecommendationsV2,
  getRecommendationEpisodeInfo,
  esSearchAll,
  esSearchStories,
  esSearchTags,
  esSearchUsers,
  searchTags,
};



// WEBPACK FOOTER //
// ./src/app/apis/search.js